import React, { useState, useEffect } from 'react';
import './App.css';
import logo from './assets/Saveera_Biotech_Logo.png';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blog from './pages/Blog';
import WhyChooseUs from './pages/WhyChooseUs';
import Contact from './pages/Contact';
import ServiceDetail from './pages/ServiceDetail';
import Maintenance from './pages/Maintenance';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';


function App() {
  // Navigation Page State
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedService, setSelectedService] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Modal State (Global Strategy Session Modal)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('consultation');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [consultSuccess, setConsultSuccess] = useState(false);
  const [consultData, setConsultData] = useState({ name: '', email: '', company: '', message: '' });

  // Scroll handler for navigation bar transition effects
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Page switcher
  const navigateTo = (target) => {
    setSelectedService(null);
    setCurrentPage(target);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Open Modal popup
  const openModal = (type = 'consultation') => {
    setModalType(type);
    setIsModalOpen(true);
    setConsultSuccess(false);
  };

  // Submit handler for strategy session modal form
  const handleModalSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setConsultSuccess(true);
      setTimeout(() => {
        setIsModalOpen(false);
        setConsultData({ name: '', email: '', company: '', message: '' });
      }, 1500);
    }, 1200);
  };

  // Render modular page component based on routing state
  const renderPage = () => {
    if (selectedService) {
      return (
        <ServiceDetail
          service={selectedService}
          onBack={() => {
            setSelectedService(null);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        />
      );
    }

    switch (currentPage) {
      case 'about':
        return <About />;
      case 'services':
        return <Services onSelectService={setSelectedService} />;
      case 'blog':
        return <Blog onSelectService={setSelectedService} />;
      case 'why-choose-us':
        return <WhyChooseUs />;
      case 'maintenance':
        return <Maintenance />;
      case 'privacy':
        return <PrivacyPolicy />;
      case 'terms':
        return <TermsOfService />;
      case 'contact':
        return <Contact />;
      case 'home':
      default:
        return (
          <Home
            navigateTo={navigateTo}
            openModal={openModal}
            onSelectService={setSelectedService}
          />
        );
    }
  };

  return (
    <div className="App">
      {/* Navigation Header */}
      <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-brand" onClick={() => navigateTo('home')}>
          <img src={logo} alt="Saveera Biotech Logo" className="nav-logo" />
        </div>

        <nav>
          <ul className="nav-links">
            <li className={`nav-item ${currentPage === 'home' ? 'active' : ''}`}>
              <button onClick={() => navigateTo('home')}>Home</button>
            </li>
            <li className={`nav-item ${currentPage === 'about' ? 'active' : ''}`}>
              <button onClick={() => navigateTo('about')}>About Us</button>
            </li>
            <li className={`nav-item ${currentPage === 'services' ? 'active' : ''}`}>
              <button onClick={() => navigateTo('services')}>Services</button>
            </li>
            <li className={`nav-item ${currentPage === 'blog' ? 'active' : ''}`}>
              <button onClick={() => navigateTo('blog')}>Blog</button>
            </li>
            <li className={`nav-item ${currentPage === 'why-choose-us' ? 'active' : ''}`}>
              <button onClick={() => navigateTo('why-choose-us')}>Why Choose Us</button>
            </li>
            <li className={`nav-item ${currentPage === 'contact' ? 'active' : ''}`}>
              <button onClick={() => navigateTo('contact')}>Contact</button>
            </li>
          </ul>
        </nav>

        <div className="nav-cta">
          <button className="btn-join" onClick={() => openModal('consultation')}>Free Consultation</button>
        </div>

        {/* Mobile Menu Toggle Button */}
        <button 
          className="mobile-menu-toggle" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle Navigation Menu"
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        {/* Responsive Mobile Drawer Panel */}
        {isMobileMenuOpen && (
          <div className="mobile-sidebar" onClick={() => setIsMobileMenuOpen(false)}>
            <div className="mobile-sidebar-content" onClick={(e) => e.stopPropagation()}>
              <div className="mobile-sidebar-header">
                <img src={logo} alt="Saveera Biotech Logo" style={{ height: '48px', objectFit: 'contain' }} />
                <button className="close-sidebar-btn" onClick={() => setIsMobileMenuOpen(false)}>✕</button>
              </div>
              <ul className="mobile-nav-links">
                <li className={currentPage === 'home' ? 'active' : ''}>
                  <button onClick={() => { navigateTo('home'); setIsMobileMenuOpen(false); }}>Home</button>
                </li>
                <li className={currentPage === 'about' ? 'active' : ''}>
                  <button onClick={() => { navigateTo('about'); setIsMobileMenuOpen(false); }}>About Us</button>
                </li>
                <li className={currentPage === 'services' ? 'active' : ''}>
                  <button onClick={() => { navigateTo('services'); setIsMobileMenuOpen(false); }}>Services</button>
                </li>
                <li className={currentPage === 'blog' ? 'active' : ''}>
                  <button onClick={() => { navigateTo('blog'); setIsMobileMenuOpen(false); }}>Blog</button>
                </li>
                <li className={currentPage === 'why-choose-us' ? 'active' : ''}>
                  <button onClick={() => { navigateTo('why-choose-us'); setIsMobileMenuOpen(false); }}>Why Choose Us</button>
                </li>
                <li className={currentPage === 'maintenance' ? 'active' : ''}>
                  <button onClick={() => { navigateTo('maintenance'); setIsMobileMenuOpen(false); }}>Service Status</button>
                </li>
                <li className={currentPage === 'contact' ? 'active' : ''}>
                  <button onClick={() => { navigateTo('contact'); setIsMobileMenuOpen(false); }}>Contact</button>
                </li>
              </ul>
              <div style={{ marginTop: '3rem', width: '100%' }}>
                <button 
                  className="btn-join" 
                  style={{ width: '100%', display: 'block', textAlign: 'center' }} 
                  onClick={() => { openModal('consultation'); setIsMobileMenuOpen(false); }}
                >
                  Free Consultation
                </button>
              </div>
            </div>
          </div>
        )}
      </header>

      {/* Main Pages Content wrapper */}
      <main className="main-wrapper">
        <div className="glow-bg"></div>
        {renderPage()}
      </main>

      {/* SYSTEM NOTICE BANNER */}
      <div
        style={{
          background: 'rgba(255, 102, 0, 0.04)',
          borderTop: '1px solid var(--border-color)',
          borderBottom: '1px solid var(--border-color)',
          padding: '1.5rem 5%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem',
          maxWidth: '100%'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', textAlign: 'left' }}>
          <span style={{ fontSize: '1.8rem' }}>🛠️</span>
          <div>
            <h5 style={{ margin: 0, fontFamily: 'var(--font-title)', textTransform: 'uppercase', fontSize: '0.95rem', color: 'var(--text-primary)', fontWeight: 800 }}>
              Website Under Maintenance
            </h5>
            <p style={{ margin: '0.2rem 0 0 0', fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: '1.4' }}>
              Our website is currently undergoing scheduled maintenance and system enhancements to improve performance and user experience.
            </p>
          </div>
        </div>
        <button
          onClick={() => navigateTo('maintenance')}
          style={{
            background: 'var(--accent-color)',
            color: 'white',
            border: 'none',
            padding: '0.5rem 1.2rem',
            borderRadius: '4px',
            fontSize: '0.85rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}
        >
          View Details
        </button>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-grid" style={{ gridTemplateColumns: '2fr 1fr 1.2fr' }}>
          <div className="footer-brand-section">
            <img src={logo} alt="Saveera Biotech Logo" className="nav-logo" style={{ marginBottom: '1.2rem' }} />
            <p>
              Saveera Biotech is an IT and digital solutions enterprise providing digital marketing, IT consultancy,
              computer programming and related technology services to help businesses grow in the digital economy.
            </p>
          </div>

          <div>
            <h4 className="footer-title">Agency Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => navigateTo('home')}>Home</button></li>
              <li><button onClick={() => navigateTo('about')}>About Us</button></li>
              <li><button onClick={() => navigateTo('services')}>Services</button></li>
              <li><button onClick={() => navigateTo('blog')}>Blog Insights</button></li>
              <li><button onClick={() => navigateTo('why-choose-us')}>Why Choose Us</button></li>
              <li><button onClick={() => navigateTo('maintenance')}>Service Status</button></li>
              <li><button onClick={() => navigateTo('contact')}>Contact Us</button></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">Contact US</h4>
            <ul className="footer-links">
              <li style={{ color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <span style={{ flexShrink: 0 }}>📞</span>
                <a href="tel:+918688334545" style={{ color: 'inherit', textDecoration: 'none' }}>+91 86883 34545</a>
              </li>
              <li style={{ color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <span style={{ flexShrink: 0 }}>✉️</span>
                <a href="mailto:info@saveerabiotech.com" style={{ color: 'inherit', textDecoration: 'none' }}>info@saveerabiotech.com</a>
              </li>
              <li style={{ color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <span style={{ flexShrink: 0 }}>✉️</span>
                <a href="mailto:HR@saveerabiotech.com" style={{ color: 'inherit', textDecoration: 'none' }}>hr@saveerabiotech.com</a>
              </li>
              <li style={{ color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <span style={{ flexShrink: 0 }}>✉️</span>
                <a href="mailto:saveeerabiotech.info@gmail.com" style={{ color: 'inherit', textDecoration: 'none', wordBreak: 'break-all' }}>saveeerabiotech.info@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* BOTTOM PILLS META BAR (PDF Page 7 SPEC) */}
        <div style={{ textAlign: 'center', padding: '2rem 1.5rem', borderTop: '1px solid rgba(255, 255, 255, 0.05)', marginTop: '3rem' }}>
          <p style={{ color: 'var(--accent-color)', fontWeight: 600, letterSpacing: '1px', fontSize: '0.95rem' }}>
            Digital Marketing &nbsp;|&nbsp; IT Consultancy &nbsp;|&nbsp; Technology Solutions &nbsp;|&nbsp; Digital Growth
          </p>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© 2026 SAVEERA BIOTECH. All rights reserved.</p>
          <ul className="footer-legal">
            <li><button onClick={() => navigateTo('privacy')}>Privacy Policy</button></li>
            <li><button onClick={() => navigateTo('terms')}>Terms of Service</button></li>
          </ul>
        </div>
      </footer>

      {/* STRATEGY CONSULTATION MODAL */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>

            {consultSuccess ? (
              <div className="success-screen" style={{ padding: '2rem 0' }}>
                <div className="success-icon-circle">✓</div>
                <h3>Submitted!</h3>
                <p>We will schedule your consultation session shortly.</p>
              </div>
            ) : (
              <>
                <h3 className="modal-title">
                  {modalType === 'consultation' ? 'Request Strategy Session' : 'Member Portal'}
                </h3>
                <p className="modal-desc">
                  Provide your details below to schedule a 1-on-1 technology and digital growth roadmap review.
                </p>

                <form onSubmit={handleModalSubmit}>
                  <div className="form-group">
                    <label htmlFor="modal-name">Full Name</label>
                    <input
                      type="text"
                      id="modal-name"
                      placeholder="John Doe"
                      className="form-input"
                      value={consultData.name}
                      onChange={(e) => setConsultData({ ...consultData, name: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="modal-email">Corporate Email</label>
                    <input
                      type="email"
                      id="modal-email"
                      placeholder="john@company.com"
                      className="form-input"
                      value={consultData.email}
                      onChange={(e) => setConsultData({ ...consultData, email: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="modal-company">Company Name</label>
                    <input
                      type="text"
                      id="modal-company"
                      placeholder="Acme Corp"
                      className="form-input"
                      value={consultData.company}
                      onChange={(e) => setConsultData({ ...consultData, company: e.target.value })}
                      required
                    />
                  </div>

                  <button type="submit" className="btn-submit" style={{ marginTop: '1rem' }} disabled={isSubmitting}>
                    {isSubmitting ? (
                      <div className="spinner"></div>
                    ) : (
                      'Schedule Session'
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
